import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Response, ExtendedResponse } from '@app/core/model';
import { LeaderboardUsersInvites, UserSimpleGamification, UserSimpleGoal } from '../../model/user.model';
import { InvitesTrial } from '@app/shell/trial-banner/model/trial.model';

@Injectable({
    providedIn: 'root',
})
export class LeaderboardHttpService {
    private httpClient = inject(HttpClient);

    /**
     * Get Leaderboard
     */
    getLeaderboardGamification(range: string, limit: number, offset: number): Observable<{ users: UserSimpleGamification[]; total: number }> {
        // set params
        const params = new HttpParams().set('limit', limit.toString()).set('offset', offset.toString());

        return this.httpClient.get<ExtendedResponse>(`api/gamification/leaderboard/${range}`, { params }).pipe(
            map((res: ExtendedResponse) => {
                return {
                    users: <UserSimpleGamification[]>res.data.items,
                    total: <number>res.data.pagination.totalItems,
                };
            }),
        );
    }

    /**
     * Get User
     */
    getUserGamification(range: string): Observable<UserSimpleGamification> {
        return this.httpClient.get<Response>(`api/gamification/profile/${range}`).pipe(
            map((res: Response) => {
                return <UserSimpleGamification>res.data;
            }),
        );
    }

    /**
     * Get User
     */
    getUserGoal(range: string): Observable<UserSimpleGoal> {
        return this.httpClient.get<Response>(`api/goal/profile/${range}`).pipe(
            map((res: Response) => {
                return <UserSimpleGoal>res.data;
            }),
        );
    }

    /**
     * Get Leaderboard
     */
    getLeaderboardGoal(range: string, limit: number, offset: number): Observable<{ users: UserSimpleGoal[]; total: number }> {
        // set params
        const params = new HttpParams().set('limit', limit.toString()).set('offset', offset.toString());

        return this.httpClient.get<ExtendedResponse>(`api/goal/leaderboard/${range}`, { params }).pipe(
            map((res: ExtendedResponse) => {
                return {
                    users: <UserSimpleGoal[]>res.data.items,
                    total: <number>res.data.pagination.totalItems,
                };
            }),
        );
    }

    getLeaderboardInvitesTrial() {
        return this.httpClient.get<Response>('api/leaderboard/invites').pipe(
            map((res: Response) => {
                return <LeaderboardUsersInvites>res.data;
            }),
        );
    }

    sendLeaderboardInvitesTrial(leaderboardUserInvites: LeaderboardUsersInvites) {
        return this.httpClient.post<Response>('api/leaderboard/invites', leaderboardUserInvites).pipe(
            map((res: Response) => {
                return <InvitesTrial>res.data.invites;
            }),
        );
    }
}
